'use client';

import { useEffect, useState } from 'react';
import { useRouter } from '@/i18n/routing';
import { useArtistProgramStatus } from './use-artist-program-status';

export function useApprovedArtistGuard() {
  const router = useRouter();
  const { refresh, status } = useArtistProgramStatus();
  const [state, setState] = useState<'checking' | 'approved'>('checking');

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const nextStatus =
          status && status !== 'reviewing' ? status : (await refresh({ force: status === 'reviewing' })).status;
        if (!cancelled && nextStatus === 'approved') {
          setState('approved');
          return;
        }
      } catch {
        if (cancelled) return;
      }
      router.replace('/artist-program');
    };
    void check();
    return () => {
      cancelled = true;
    };
  }, [refresh, router, status]);

  return state;
}
